import coreModule from '../core_module';
import videojs from 'video.js';
import { appEvents } from 'app/core/core';

let videoJs = [
  '$timeout',
  $timeout => {
    return {
      scope: { src: '=', offset: '=', sync: '=', player: '=' },
      link: function(scope, element) {
        // We are wrapping the videojs call inside a $timeout() call to wait for
        // the children to render. In this case the <source> tag ng-src attribute.
        $timeout(() => {
          let tag = element.children()[0];

          let player = videojs(tag, {
            plugins: {
              framebyframe: {
                fps: 29.97,
                steps: [
                  {
                    text: '<i class="fa fa-step-backward" aria-hidden="true" title="Step backwards 1 frame"></i>',
                    step: -1,
                  },
                  {
                    text: '<i class="fa fa-step-forward" aria-hidden="true" title="Step forward 1 frame"></i>',
                    step: 1,
                  },
                ],
              },
            },
          });

          scope.player = player;
          console.log('Video offset is', scope.offset);

          if (scope.offset !== undefined) {
            player.on('timeupdate', function() {
              // console.log("timeupdate", this.currentTime());
              // Update the hover if using the frame-by-frame buttons
              if (player.paused()) {
                sendHover();
              }
            });
          }

          player.on('play', () => {
            console.log('play');
            updateHover();
          });

          player.on('pause', () => {
            console.log('pause');
            cancelAnimationFrame(request);
          });

          let sendHover = () => {
            if (!scope.sync) {
              return;
            }

            let timeMs = (player.currentTime() + scope.offset) * 1000;
            let pos = {
              panelRelY: 0.5,
              x: timeMs,
            };
            let evt = { pos: pos, panel: { id: -1 }, isVideoSync: true };
            appEvents.emit('graph-hover', evt);
          };

          let request;
          let updateHover = () => {
            request = requestAnimationFrame(updateHover);
            sendHover();
          };
        });
      },

      template: `
      <video ng-attr-id="thevideotag" class="video-js vjs-big-play-centered"
        controls preload="auto" style="margin: auto;">
        <source ng-src="{{ src }}" type="video/mp4">
        Your browser does not support the video tag.
      </video>`,
    };
  },
];

coreModule.directive('videoJs', videoJs);

// Below is a video.js plugin for frame-by-frame skipping

var VjsButton = videojs.getComponent('Button');
var FBFButton = videojs.extend(VjsButton, {
  constructor: function(player, options) {
    VjsButton.call(this, player, options);
    this.player = player;
    this.frameTime = 1 / options.fps;
    this.step_size = options.value;
    this.on('click', this.onClick);
  },

  onClick: function() {
    // Start by pausing the player
    this.player.pause();
    // Calculate movement distance
    var dist = this.frameTime * this.step_size;
    this.player.currentTime(this.player.currentTime() + dist);
  },
});

function framebyframe(options) {
  var player = this;

  player.ready(function() {
    options.steps.forEach(function(opt) {
      player.controlBar.addChild(
        new FBFButton(player, {
          el: videojs.dom.createEl(
            'button',
            {
              className: 'vjs-res-button vjs-control',
              innerHTML:
                '<div class="vjs-control-content" ' +
                'style="font-size: 11px; line-height: 28px;">' +
                '<span class="vjs-fbf">' +
                opt.text +
                '</span></div>',
            },
            {
              role: 'button',
            }
          ),
          value: opt.step,
          fps: options.fps,
        }),
        {},
        opt.index
      );
    });
  });
}
videojs.registerPlugin('framebyframe', framebyframe);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./public/app/core/directives/videojs.ts